import { supabase } from "@/integrations/supabase/client";

type GenerateKvkkPdfParams = {
  phone: string;
  customerId?: string | null;
};

export type GenerateKvkkPdfResult = {
  success: boolean;
  report_id: string;
  latest_ledger_id: string;
  pdf_storage_path: string;
  signed_url: string;
  expires_in_seconds: number;
};

export const generateKvkkPdfReport = async (
  params: GenerateKvkkPdfParams,
): Promise<GenerateKvkkPdfResult> => {
  const { data, error } = await supabase.functions.invoke("generate-kvkk-pdf", {
    body: {
      phone: params.phone,
      customer_id: params.customerId ?? null,
    },
  });

  if (error) {
    throw new Error(error.message || "KVKK PDF generation failed");
  }

  if (!data?.signed_url) {
    throw new Error("KVKK PDF signed URL is missing");
  }

  return data as GenerateKvkkPdfResult;
};

export const downloadFromSignedUrl = (url: string) => {
  window.open(url, "_blank", "noopener,noreferrer");
};
